export default __webpack_public_path__ + "static/media/background.3ce8dc21.png";